import { normalizeStatus } from './statusNormalizer';

export const getAgreementWithLowestStatus = (agreements) => {
    const statusMap = new Map([
        ['WaitingOnAssets', 0],
        ['AssetsReceived', 1],
        ['InProduction', 2],
        ['UnderReview', 3],
        ['ProofSent', 4],
        ['ProofRevisionNeeded', 5],
        ['ProofRevisionSent', 6],
        ['Approval', 7],
        ['Scheduled', 8],
        ['PostBroadcastRevisionNeeded', 9],
        ['PostBroadcastRevisionSent', 10],
        ['PostBroadcastRevisionApproved', 11]
    ]);

    let lowestStatus = Number.POSITIVE_INFINITY;
    let bestAgreement = null;

    agreements?.forEach(agreement => {
        agreement.Contracts?.forEach(contract => {
            const normalized = normalizeStatus(contract.WebAdStatusDisplayName || contract.AdStatus);
            const statusIndex = statusMap.get(normalized);
            if (statusIndex !== undefined && statusIndex < lowestStatus) {
                lowestStatus = statusIndex;
                bestAgreement = agreement;
            }
        });
    });

    return bestAgreement;
};
